import {ApiUrls} from 'shared/config/model/urls';

import React from 'react';
import {SubmitHandler} from 'react-hook-form';
import {t} from '@lingui/core/macro';

import ModalBlockButton from 'shared/ui/Button/ModalBlockButton/ModalBlockButton';
import {ExportResult, useExportRequest} from 'entities/monitor';
import {IDomainIncidentsFiltersForm} from 'features/domain/model/DomainIncident/IDomainIncidentsFiltersForm';
import IDomainIncidentsExportRequest from 'features/domain/model/DomainIncident/IDomainIncidentsExportRequest';
import {allValueToUndefined, dateRangeToDateAfterBefore} from 'shared/lib/filterHelper';

import DomainIncidentsFiltersForm
    from '../DomainIncidentsFilters/DomainIncidentsFiltersForm';

interface IDomainIncidentsExportFormHandlerProps {
    handleClose: () => void,
}

const DomainIncidentsExportFormHandler: React.FC<IDomainIncidentsExportFormHandlerProps> = ({handleClose}) => {
    const {result, isLoading, progress, submit, reset} = useExportRequest(ApiUrls.DOMAIN_INCIDENTS_EXPORT);

    const onSubmit: SubmitHandler<IDomainIncidentsFiltersForm> = async({
        domain,
        domainMonitor,
        type,
        // eslint-disable-next-line camelcase
        created_at,
        // eslint-disable-next-line camelcase
        expire_at,
        // eslint-disable-next-line camelcase
        resolved_at,
        orderBy,
    }) => {
        const data: IDomainIncidentsExportRequest = {
            domainMonitorId: allValueToUndefined(domainMonitor),
            domain,
            type,
            created_at: dateRangeToDateAfterBefore(created_at),
            expire_at: dateRangeToDateAfterBefore(expire_at),
            resolved_at: dateRangeToDateAfterBefore(resolved_at),
            orderBy,
        };

        await submit(data);
    };

    const handleCloseResult = () => {
        handleClose();
        reset();
    };

    if (result) {
        return (
            <ExportResult
                result={result}
                countLabel={t`Экспортировано инцидентов доменов`}
                handleClose={handleCloseResult}
            />
        );
    }

    return (
        <DomainIncidentsFiltersForm
            onSubmit={onSubmit}
            button={
                <ModalBlockButton
                    primaryButtonText={t`Экспортировать`}
                    primaryButtonType="submit"
                    primaryButtonLoading={isLoading}
                    primaryButtonDisabled={isLoading}
                    secondaryButtonOnClick={handleClose}
                    progress={progress}
                />
            }
        />
    );
};

export default DomainIncidentsExportFormHandler;
